import React from 'react';
import Button from '../components/Button';

const Contact: React.FC = () => {
  return (
    <div className="max-w-3xl mx-auto px-6 py-12">
      <div className="text-center mb-16">
        <h1 className="text-5xl font-bold tracking-tight mb-6 text-black">Contact Us</h1>
        <p className="text-xl text-gray-600">
          Connect with your Agentic team today to explore limitless possibilities.
        </p>
      </div>

      <div className="bg-white border border-gray-200 rounded-2xl p-8 md:p-12 shadow-2xl shadow-gray-200/50">
        <div className="flex flex-col gap-8">
          {/* Direct Email Display */}
          <div className="bg-gray-50 rounded-xl p-6 border border-gray-100 text-center overflow-hidden">
            <h3 className="text-lg font-medium text-black mb-2">Direct Contact</h3>
            <div className="block text-lg sm:text-2xl md:text-3xl font-light text-[#81D8D0] break-words">
              george@tiffany.com
            </div>
            <p className="text-sm text-gray-500 mt-4">Tiffany & Co. Agentic Team</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
